<template>
  <van-dialog
    v-model="showModal"
    title="选择星期"
    class="cgq_modal"
    show-cancel-button
    @confirm="modalConfirm"
    @close="close"
  >
    <template slot="default">
      <div class="tags">
        <div
          class="tag"
          v-for="(item, index) in list"
          :key="item.id"
          :class="item.check && 'active'"
          @click="handleTagClick(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
    </template>
  </van-dialog>
</template>

<script>
import { format } from "echarts/lib/export";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    confirm: {
      type: Function,
      default: () => {}
    }
  },

  watch: {
    show(v) {
      console.log("v:", v);
      this.showModal = v;
      // 还需要解析 传来的week值
      this.formaterWeek();
    }
  },

  data() {
    return {
      list: [],
      showModal: false
    };
  },

  mounted() {
    this.formaterWeek();
  },

  methods: {
    formaterWeek() {
      this.list = [1, 2, 3, 4, 5, 6, 7].map(item => {
        const chinese = this.$noToChinese(item);
        console.log("chinese:", chinese);
        let check = false;
        if (this.data && this.data.length) {
          const tar = this.data.find(o => o.id === item);
          if (tar) {
            check = true;
          }
        }

        return {
          id: item,
          name: `星期${chinese === "七" ? "日" : chinese}`,
          check
        };
      });
    },

    handleTagClick(item, index) {
      this.list[index].check = !this.list[index].check;
    },

    modalConfirm() {
      const list = this.list.filter(o => o.check);
      console.log("list:", list);
      this.$emit("confirm", list);
    },
    close() {
      this.$emit("cancel", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.cgq_modal {
  width: 80% !important;
  border-radius: 0 !important;
}

/deep/.van-dialog__content {
  padding: 10px;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .tag {
    border: 1px solid #999;
    padding: 4px 8px;
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .active {
    background: #4776ea;
    border-color: #4776ea;
    color: #ffffff;
  }

  &:after {
    content: "星期日";
    box-sizing: border-box;
    padding: 4px 8px;
    opacity: 0;
  }
}
</style>
